import app from 'flarum/forum/app';
import addDiscussionComposerItem from './addDiscussionComposerItem';
import addScheduledPostsDropdown from './addScheduledPostsDropdown';
import ScheduledPostListState from './states/ScheduledPostListState';

export { default as extend } from './extend';

app.initializers.add('glowingblue/scheduled-posts', () => {
	app.scheduledPosts = new ScheduledPostListState();

	// Add UI for the discussion composer (creating or updating a discussion/post)
	addDiscussionComposerItem();
	// Add a dropdown menu to list the scheduled posts (like the notifications dropdown)
	addScheduledPostsDropdown();
});
